import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { Config, Data } from '../../../utils/newTableHelper';
import { HomeOrdersTypes } from './types';

export const loadOrdersRequest = () => action(HomeOrdersTypes.LOAD_REQUEST);
export const loadSuccess = (data: Data[], config: Config) =>
  action(HomeOrdersTypes.LOAD_SUCCESS, { data, config });
export const loadFailure = (error: ResponseError) =>
  action(HomeOrdersTypes.LOAD_FAILURE, { error });
